const PATTERN_LABEL_ID = {
  'mfa-all-users': 'AI_RISK_REPORT.IDENTITY.CA.BASELINE.PATTERN.MFA_ALL',
  'block-legacy': 'AI_RISK_REPORT.IDENTITY.CA.BASELINE.PATTERN.BLOCK_LEGACY',
  'phish-admins': 'AI_RISK_REPORT.IDENTITY.CA.BASELINE.PATTERN.PHISH_ADMINS',
  'signin-risk': 'AI_RISK_REPORT.IDENTITY.CA.BASELINE.PATTERN.SIGNIN_RISK',
  'user-risk': 'AI_RISK_REPORT.IDENTITY.CA.BASELINE.PATTERN.USER_RISK',
  'compliant-device': 'AI_RISK_REPORT.IDENTITY.CA.BASELINE.PATTERN.COMPLIANT_DEVICE',
}

const REQUIREMENT_LABEL_ID = {
  enabled: 'AI_RISK_REPORT.IDENTITY.CA.REQ.ENABLED',
  allUsers: 'AI_RISK_REPORT.IDENTITY.CA.REQ.ALL_USERS',
  adminRoles: 'AI_RISK_REPORT.IDENTITY.CA.REQ.TARGETS_ADMIN_ROLES',
  allApps: 'AI_RISK_REPORT.IDENTITY.CA.REQ.ALL_APPS',
  m365Apps: 'AI_RISK_REPORT.IDENTITY.CA.REQ.M365_APPS',
  allClientApps: 'AI_RISK_REPORT.IDENTITY.CA.REQ.ALL_CLIENT_APPS',
  legacyClientApps: 'AI_RISK_REPORT.IDENTITY.CA.REQ.LEGACY_CLIENT_APPS',
  grantMfa: 'AI_RISK_REPORT.IDENTITY.CA.REQ.GRANT_MFA',
  grantBlock: 'AI_RISK_REPORT.IDENTITY.CA.REQ.GRANT_BLOCK',
  grantCompliantDevice: 'AI_RISK_REPORT.IDENTITY.CA.REQ.GRANT_COMPLIANT_DEVICE',
  grantPhishing: 'AI_RISK_REPORT.IDENTITY.CA.REQ.GRANT_PHISHING',
  grantMfaOrBlock: 'AI_RISK_REPORT.IDENTITY.CA.REQ.GRANT_MFA_OR_BLOCK',
  grantRecovery: 'AI_RISK_REPORT.IDENTITY.CA.REQ.GRANT_RECOVERY',
  signInRisk: 'AI_RISK_REPORT.IDENTITY.CA.REQ.SIGNIN_RISK_SET',
  userRisk: 'AI_RISK_REPORT.IDENTITY.CA.REQ.USER_RISK_SET',
}

const POLICY_STATE_PRESENTATION = {
  enabled: {
    messageId: 'AI_RISK_REPORT.IDENTITY.CA.STATE_ENFORCED',
    sortValue: 'enforced',
  },
  report_only: {
    messageId: 'AI_RISK_REPORT.IDENTITY.CA.STATE_REPORT_ONLY',
    sortValue: 'reportOnly',
  },
  disabled: {
    messageId: 'AI_RISK_REPORT.IDENTITY.CA.STATE_DISABLED',
    sortValue: 'disabled',
  },
  unknown: {
    messageId: 'AI_RISK_REPORT.LABEL.UNKNOWN',
    sortValue: 'unknown',
  },
}

const UNKNOWN_POLICY_PRESENTATION = POLICY_STATE_PRESENTATION.unknown

export const getConditionalAccessPolicyName = (policy) => policy?.displayName || policy?.policyId || ''

export const getConditionalAccessPolicyStatePresentation = (policy) =>
  POLICY_STATE_PRESENTATION[policy?.state] ?? UNKNOWN_POLICY_PRESENTATION

export const buildConditionalAccessBaselineRows = (baselines = []) =>
  baselines.flatMap((baseline) => {
    const labelId = PATTERN_LABEL_ID[baseline.id]
    if (!labelId) return []

    return [
      {
        ...baseline,
        key: baseline.id,
        labelId,
        requirements: (baseline.requirements ?? []).flatMap((requirement) => {
          const requirementLabelId = REQUIREMENT_LABEL_ID[requirement.id]
          return requirementLabelId ? [{ ...requirement, key: requirement.id, labelId: requirementLabelId }] : []
        }),
      },
    ]
  })
